/* istanbul ignore file */
import { Link } from 'react-router-dom';
import { useHandbookUrl } from '../../handbookRoute';
import { HandbookItemStructure } from '../../handbookStructureService';
import { scrollToHash } from 'framework/utils';
import { HashLink } from 'react-router-hash-link';
import { Typography } from '@mui/material';

const HandbookSubpagesListLayout = ({ pageStructure }: { pageStructure: HandbookItemStructure }) => {
  const { getListUrl, getSingleEntityUrl } = useHandbookUrl();

  const getLink = (pagePathname: string, pageTitle: string) => {
    if (pagePathname.startsWith('/') && pagePathname.includes('#')) {
      return (
        <HashLink to={`${getListUrl()}${pagePathname}`} scroll={(el: HTMLElement) => scrollToHash(el)}>
          {pageTitle}
        </HashLink>
      );
    } else {
      return <Link to={getSingleEntityUrl(pagePathname.slice(1))}>{pageTitle}</Link>;
    }
  };

  const renderTableOfContent = (data: HandbookItemStructure[]) => {
    return data.map(({ pagePathname, subPages, pageTitle }) => (
      <li key={pagePathname}>
        {getLink(pagePathname, pageTitle)}

        {subPages?.length ? <ul>{renderTableOfContent(subPages)}</ul> : null}
      </li>
    ));
  };

  return (
    <>
      <Typography variant="h2" component="h2">
        {pageStructure.pageTitle} pages
      </Typography>
      <ul>{renderTableOfContent(pageStructure.subPages || [])}</ul>
    </>
  );
};

export default HandbookSubpagesListLayout;
